<template>
  <vx-card title="Заявка на вызов охраны" class="mb-8">
    <div class="vx-row">
      <div class="vx-col flex-1">
        <table class="w-3/5">
          <tr>
            <td class="font-semibold">Номер обращения</td>
            <td class="pl-4">
              <span class="text-primary">#{{ requestSecurity.id }}</span>
            </td>
          </tr>
          <tr>
            <td class="font-semibold">Дата создания</td>
            <td class="pl-4">
              <span class="text-primary">{{
                requestSecurity.date_created
              }}</span>
            </td>
          </tr>
        </table>
      </div>

      <div v-if="requestSecurity.user" class="vx-col flex-1">
        <table>
          <tr>
            <td class="font-semibold">Автор заявки</td>
            <td class="pl-4">
              <span class="text-primary">{{
                requestSecurity.user.full_name
              }}</span>
            </td>
          </tr>
          <tr>
            <td class="font-semibold">Номер телефона</td>
            <td class="pl-4">
              <a
                :href="`tel:${requestSecurity.user.phone}`"
                class="text-primary"
                >{{ requestSecurity.user.phone }}</a
              >
            </td>
          </tr>
          <tr>
            <td class="font-semibold">Адрес</td>
            <td class="pl-4">
              <span class="text-primary"
                >{{ requestSecurity.home.county_type.name }}, участок #
                {{ requestSecurity.home.homestead_number }}, ул.
                {{ requestSecurity.home.address }}</span
              >
            </td>
          </tr>
        </table>
      </div>
    </div>
  </vx-card>
</template>


<script>
import { API_URL, countyType } from "@/.env";

export default {
  data: () => ({
    requestSecurity: [],

    countyType,
    BASE_URL: API_URL,
  }),
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    getSecurityRequest(idRequest) {
      this.$vs.loading();
      this.$load(async () => {
        let res = (await this.$api.security.getSecurityRequest(idRequest)).data;
        res.date_created = this.formatDate(res.date_created);

        res.home.county_type = this.countyType.find(
          (x) => (x.id = res.home.county_type)
        );

        this.requestSecurity = res;
        this.$vs.loading.close();
      });
    },
  },
  created() {},
  mounted() {
    this.getSecurityRequest(this.$route.params.id);
  },
};
</script>